import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

const GRADIENT_ID = 'cl-brand-grad';

function sparklePath(cx, cy, size) {
  const s = size / 2;
  const d = size * 0.22;
  return `M${cx} ${cy - s} L${cx + d} ${cy - d} L${cx + s} ${cy} L${cx + d} ${cy + d} L${cx} ${cy + s} L${cx - d} ${cy + d} L${cx - s} ${cy} L${cx - d} ${cy - d} Z`;
}

export default function BrandMark({ size = 36, gradientId = GRADIENT_ID }) {
  const id = gradientId;

  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      sx={{ display: 'block', flexShrink: 0 }}
    >
      <defs>
        <linearGradient id={id} x1="6" y1="4" x2="30" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7c3aed" />
          <stop offset="1" stopColor="#0891b2" />
        </linearGradient>
      </defs>
      <circle cx="18" cy="18" r="18" fill={`url(#${id})`} />
      <path d={sparklePath(12, 17, 11)} fill="#fff" />
      <path d={sparklePath(22.5, 11.5, 6.5)} fill="#fff" />
      <path d={sparklePath(23.5, 23, 5.5)} fill="#fff" />
    </Box>
  );
}

BrandMark.propTypes = {
  size: PropTypes.number,
  gradientId: PropTypes.string
};
